"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var serviceTypeBanner = function serviceTypeBanner(serviceTypes) {
  if (!(0, _lodash.isArray)(serviceTypes)) {
    return serviceTypes.name;
  }
  var firstSTName = serviceTypes[0] && serviceTypes[0].name;
  return serviceTypes.length > 1 ? "\n    ".concat(firstSTName, " and ").concat(serviceTypes.length - 1, " more\n  ") : firstSTName;
};
var _default = exports["default"] = serviceTypeBanner;